export const INPUT_STYLES = {
  default:
    'width: 99%; height: 40px; padding: 12px; padding-left: 16px; border-width: 2px; background-color: #FFFFFF; margin-top: 1px; margin-left: 1px; border: 1px solid #B4C2CB; border-radius: 6px; box-sizing: border-box; font-size: 14px; line-height: 20px; font-family: Montserrat, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";',
  valid:
    'background-color: #CDFFE6; outline: 1px solid transparent; outline-offset: 1px; box-shadow: 0 0 0 0px #fff, 0 0 0 1px #1f871d; border-color: #1f871d;',
  focusNumber:
    'outline: 1px solid transparent; outline-offset: 1px; box-shadow: 0 0 0 0px #fff, 0 0 0 1px #2563eb; border-color: #2563eb;',
  blurNumber:
    'outline: 2px solid transparent; outline-offset: 2px; box-shadow: none; border-color: #B4C2CB;',
  validCvv: 'background-color: #CDFFE6;',
  invalidCvv: 'background-color: #FFFFFF;',
  validNumber:
    'background-color: #CDFFE6; outline: 1px solid transparent; outline-offset: 1px; box-shadow: 0 0 0 0px #fff, 0 0 0 1px #1f871d; border-color: #1f871d;',
  invalidNumber: 'background-color: #FFFFFF;',
  errorNumber:
    'outline: 1px solid transparent; outline-offset: 1px; box-shadow: 0 0 0 0px #fff, 0 0 0 1px #E90200; border-color: #E90200;'
};
